/**
 *  Filename ....: servicedefinition.component.ts
 *  Created by ..: ianday
 *  on Date .....: 10/9/23
 **/
import { AfterContentInit, Component, HostListener, Injectable, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { TransactionHistoryComponent } from "../../../components/transaction-history/transaction-history";
import { TransactionHistoryService } from "../../../services/transactionhistory.service";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { Settings } from "../../../services/settings";
import { DwUtils } from "../../../components/utils/dw-utils";
import { ConfirmDialogComponent, ConfirmDialogModel } from "../../../components/shared/confirmation-dialog/confirmation-dialog.component";
import { ValidationResult } from "../../../models/validation-result";
import { ServiceDef } from "../../../models/service-def";
import { ServiceRequestsService } from "../../../services/service-requests.service";
import { ServiceDefService } from "../../../services/servicedef.service";
import { RegionsComponent } from "./regions/regions.component";
import { UOMRec } from "../../settings/requesttypes/requesttypes.component";
import { ServiceRequestType } from "../../../models/service-request-type";
import {DataRecord} from "../../requests/commands/req-status/req-status.component";

@Component({
	selector: 'app-servicedefinition',
	templateUrl: './servicedefinition.component.html',
	styleUrls: ['./servicedefinition.component.css']
})
@Injectable()
export class ServiceDefinitionComponent implements OnInit, AfterContentInit {

	/*** Header / Query Strip Variables ****/
	public formTitle = 'Service Definitions';
	public pagination: string;

	/*** Editing variables ***/
	public isEditing: boolean | null = false;
	public isAdd: boolean | null = false;
	public records: ServiceDef[];
	public selectedRecord: ServiceDef;
	public historyRecord: ServiceDef;
	public serviceRequestTypes: any;
	public Idx: number | null = -1;
	public strErr: string | null = '';
	public dataSource: MatTableDataSource<ServiceDef>;
	public renderedData: Array<any>;
	public result: boolean | null = false;
	public disabledFlag: boolean | null = true;

	/**** Query strip filter settings ***/
	public selectedStatusFilter: string | null = 'Active';
	public selectedViewFilter: string | null = 'List';
	public contentClassWithBanner: string | null = 'dwtable-container';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
	public contentClassName: string | null = 'dwtable-container';

	/*** Record Table / card table  ***/
	public displayedColumns: string[] = ['id', 'requestType', 'description', 'serviceRequestTypeId', 'unitOfMeasure'];

	/***** Control Strip Button Visibility ***/
	public visibleAdd: boolean | null = false;
	public visibleModify: boolean | null = false;
	public visibleDelete: boolean | null = false;
	public visibleQualificationsMappingButton: boolean | null = false;
	public visibleStatus: boolean | null = false;
	public statusEnabled: boolean | null = false;
	public visibleAutoMatch: boolean | null = false;
	public automatchEnabled: boolean | null = false;

	/***** Tab Detail Section *****/
	public selectedTabIndex: number | null = 0;

	public id: any | null = '';
	public description: any | null = '';
	public serviceRequestTypeId: any | null = 0;
	public durationDays: number = 0;
	public repeatFrequency: number = 0;
	public repeatable: string | null = 'No';
	public unitOfMeasure: string | null = '';
	public activeStatus: string | null = '';
	public useAutomatch: string | null = '';

	public selectedRequestType: ServiceRequestType;

	public uomList: any;
	public agencyId: number;
	/***** Side drawer ****/

	public propContainerState: boolean | null = false;
	public visiblePropertiesTab: boolean | null = true;
	public visibleNotesTab: boolean | null = true;

	public dowList:any;
	public selectedDow:any;
	public dowSet = new Map();

	/** Dialogs */

	displayQualificationsMappingDlg = false;
	strQualificationsdialogHeader = '';

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;
	@ViewChild('regions', { static: true }) regions: RegionsComponent;

	constructor(private serviceDefService: ServiceDefService,
		private serviceRequestsService: ServiceRequestsService,
		private txService: TransactionHistoryService,
		public dialog: MatDialog) {
		this.selectedRecord = new ServiceDef();
		this.agencyId = Settings.getInstance().loggedInUser.agencyId;

		this.dowList = [];
		this.dowList.push(new Object({id: 'Mon', description: 'Monday'}));
		this.dowList.push(new Object({id: 'Tue', description: 'Tuesday'}));
		this.dowList.push(new Object({id: 'Wed', description: 'Wednesday'}));
		this.dowList.push(new Object({id: 'Thu', description: 'Thursday'}));
		this.dowList.push(new Object({id: 'Fri', description: 'Friday'}));
		this.dowList.push(new Object({id: 'Sat', description: 'Saturday'}));
		this.dowList.push(new Object({id: 'Sun', description: 'Sunday'}));

	}

	public ngOnInit() {
		this.visibleAdd = Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEFS_ADD', "EXECUTE");
		this.visibleModify = Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEFS_EDIT', "EXECUTE");
		if(Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEFS', "WRITE")) {
			this.visibleDelete = false;
		}
		if(Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEF_QUALIFICATIONS', "READ")) {
			this.visibleQualificationsMappingButton = true;
			this.displayedColumns.push('btnDetails');
		}
		if(Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEF_AUTOMATCH', "READ")) {
			this.visibleStatus = true;
			this.displayedColumns.push('useAutomatch');
		}
		if(Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEF_AUTOMATCH', "WRITE")) {
			this.statusEnabled = true;
		}
		if(Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEF_STATUS', "READ")) {
			this.visibleAutoMatch = true;
			this.displayedColumns.push('activeStatus');
		}
		if(Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEF_STATUS', "WRITE")) {
			this.automatchEnabled = true;
		}
		
	}
	public ngAfterContentInit() {

		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}

		this.queryServiceRequestTypes();

		this.serviceDefService.getActiveUnitOfMeasures().subscribe(
			(result) => {
				this.uomList = new Array();
				for (const rec of result) {
					this.uomList.push(new UOMRec(rec.description, rec.description));
				}
				this.queryRecords();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching UOMs')
			});
	}
	public queryServiceRequestTypes(): void {
		this.serviceRequestTypes = new Array();
		this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
			(result) => {
				this.serviceRequestTypes = result;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'called from service definition');
			}
		)
	}
	/*** Query Records from the Service ***/
	public queryRecords() {

		this.serviceDefService.getAllServiceDefsForAgency(this.agencyId).subscribe(
			(result) => {
				this.records = [];
				for(let rec of result ) {
					rec['requestType'] = this.lblDescFmt(rec.serviceRequestTypeId);
					this.records.push(rec);
				}

				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort;
				this.onChangeStatusFilterValue();
				this.setPagination(-1, this.dataSource.data.length);
				DwUtils.setFocus('txtFilter');
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve service defs data from the service');
			}
		);
	}
	/*** Display the number of records from the total ***/
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}
	public lblDescFmt(id: number): string {
		if (id === null) {
			return '';
		}
		let retVal;

		try {
			retVal = this.serviceRequestTypes.find(s => s.id === id).description;
		} catch { return ''; }
		 return retVal;
	}
	public onChangeStatusFilterValue() {
		const dataTemp: ServiceDef[] = [];
		this.clearFilter();

		for (const rec of this.records) {
			if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
	}
	public onStatusChange() {

		if(this.selectedRecord.activeStatus !== 'Active') {
			this.selectedRecord.useAutomatch = 'InActive';
		}
		this.serviceDefService.updateServiceDef(this.selectedRecord).subscribe(
			(data) => {
				this.txService.updateTransactionHistory(this.historyRecord,
				this.selectedRecord, 'ServiceDefs', this.selectedRecord.id, ['requestType']);
				// no user feedback, just apply the filter ...
				this.onChangeStatusFilterValue();
			});
	}
	public onUseAutomatchChange() {

		if ((this.selectedRecord.activeStatus !== 'Active') && (this.selectedRecord.useAutomatch === 'Active')) {
			this.selectedRecord.activeStatus = 'Active';
		}
		this.serviceDefService.updateServiceDef(this.selectedRecord).subscribe(
			(data) => {
				this.txService.updateTransactionHistory(this.historyRecord,
				this.selectedRecord, 'ServiceDefs', this.selectedRecord.id, ['requestType']);
				// no user feedback, just apply the filter ...
				this.onChangeStatusFilterValue();
			});

	}
	public dowSelectionChange(event): void {

	}
	public doTabChange(event): void {

		if(this.selectedRecord !== undefined) {
			this.displayDetail(this.selectedRecord);
		}

	}
	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {

		if (event.direction === 'asc') {
			if(event.active === 'id') {
				this.records.sort((a, b) =>
					a[event.active] - (b[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if(event.active === 'id') {
				this.records.sort((a, b) =>
					b[event.active] - (a[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}

		this.dataSource.data = this.records;
		this.onChangeStatusFilterValue();
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public clearFilter() {
		if (this.isEditing) {
			return;
		}
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
		DwUtils.setFocus('txtFilter');
	}
	public applyFilter(filterValue: string) {
		if (this.isEditing) {
			return;
		}
		if(filterValue === undefined) {
			return;
		}
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}
	public unSelectRow() {

		this.Idx = -1;
		this.selectedRecord = new ServiceDef();
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDetail(this.selectedRecord);

	}
	public displayDetail(record: ServiceDef) {
		if (record === undefined) {
			return;
		}
		this.strErr = '';
		this.id = record.id;
		this.description = record.description;
		this.unitOfMeasure = record.unitOfMeasure;
		this.durationDays = record.durationDays;
		this.repeatFrequency = record.repeatFrequency;
		this.repeatable = record.repeatable;
		this.activeStatus = record.activeStatus.toString();
		this.useAutomatch = record.useAutomatch.toString();
		this.serviceRequestTypeId = record.serviceRequestTypeId;
		if(record.dowAvailable === null) {
			record.dowAvailable = '';
		}
		this.selectedDow = record.dowAvailable.split(',');
		this.regions.serviceDefId = record.id;
		this.regions.queryServiceRegions();
		this.history.onShowHandler('ServiceDefs', 'id', record.id.toString());
	}
	public clear() {
		this.id = '';
		this.description = '';
		this.activeStatus = '';
		this.useAutomatch = '';
		this.unitOfMeasure = '';
		this.durationDays = 0;
		this.serviceRequestTypeId = 0;
		this.selectedDow = '';
		this.strErr = '';
		this.regions.checklistSelection.clear();
		this.repeatFrequency = 0;
		this.repeatable = 'No';
	}
	public addModifyRecord(isAdd: boolean) {
		this.isAdd = isAdd;
		this.isEditing = true;

		if (this.isAdd) {
			this.selectedTabIndex = 0;
			this.clear();
			this.id = 0;
			this.activeStatus = 'Active';
			this.useAutomatch = 'InActive';
			this.regions.serviceDefId = 0;
			this.repeatable = 'No';
			this.regions.checklistSelection.clear();

		} else {
			// store the history record
			if(this.selectedTabIndex === 0) {
				this.historyRecord = this.selectedRecord;
				DwUtils.setFocus('description');
			}
		}
	}
	public setServiceType(): void {

		if (this.serviceRequestTypeId > 0) {
			this.selectedRequestType = this.serviceRequestTypes.find(s => s.id === this.serviceRequestTypeId);
			if (this.selectedRequestType !== undefined) {
				this.durationDays = this.selectedRequestType.baseDurationDays;
				this.unitOfMeasure = this.selectedRequestType.unitOfMeasure;
			}
		}
	}
	public removeRecord() {
		const message = 'Remove Service Definition: "' + this.selectedRecord.description + '" - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.serviceDefService.deleteServiceDef(this.selectedRecord.id).subscribe(
					(data) => {
						// remove the row from the table.
						const localIdx = this.records.findIndex(s => s.id === this.selectedRecord.id)
						this.records.splice(localIdx, 1);
						this.dataSource.data = this.records;
						this.Idx = -1;
						this.clear();
					},
					(error) => {
						Settings.getInstance().handleError(error);
					});
			}
		});
	}
	public tableKeyDown(event: KeyboardEvent) {
		if (this.isEditing) {
			return;
		}

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}

		if (this.regions.checklistSelection.isEmpty()) {
			this.strErr = 'Warning: No Regions have been selected for this service';
		}
		return true;
	}
	public checkDurationBounds(serviceDuration: number): boolean {

		const baseDurationDays = this.serviceRequestTypes.find(s => s.id === this.selectedRecord.serviceRequestTypeId).baseDurationDays

		if (this.selectedRecord.durationDays > baseDurationDays) {
			this.strErr = 'Error: The duration for this service cannot be more than ' + baseDurationDays + ' day(s)';
			return false
		}

		return true;
	}
	public submitRecord() {

		this.selectedRecord = new ServiceDef();
		this.selectedRecord.id = this.id;
		this.selectedRecord.agencyId = this.agencyId;
		this.selectedRecord.description = DwUtils.capitalize(this.description);
		this.selectedRecord.unitOfMeasure = this.unitOfMeasure;
		this.selectedRecord.durationDays = this.durationDays;
		this.selectedRecord.activeStatus = this.activeStatus;
		this.selectedRecord.useAutomatch = this.useAutomatch;
		this.selectedRecord.dowAvailable = this.selectedDow.toString();
		this.selectedRecord.serviceRequestTypeId = this.serviceRequestTypeId;
		this.selectedRecord.repeatFrequency = this.repeatFrequency;
		this.selectedRecord.repeatable = this.repeatable;

		this.strErr = '';

		if (!this.validateFields()) {
			return;
		}
		if (!this.checkDurationBounds(this.selectedRecord.durationDays)) {
			return;
		}

		if (this.isAdd === true) {
			this.serviceDefService.createServiceDef(this.selectedRecord).subscribe(
				(data) => {
					this.selectedRecord.id = data.id;
					this.regions.serviceDefId = this.selectedRecord.id;
					this.regions.submitSelectedRegions();
					this.isEditing = false;
					/*** add a transaction history record ***/
					this.txService.createTransactionHistory('ServiceDefs', this.selectedRecord.id);
				},
				(error) => {
					this.strErr = 'Error: The server could not add/submit this record';
					return;
				}
			);
		} else {

			this.serviceDefService.updateServiceDef(this.selectedRecord).subscribe(
				(data) => {
					this.isEditing = false;
					this.regions.serviceDefId = this.selectedRecord.id;
					this.regions.submitSelectedRegions();
				},
				(error) => {
					this.strErr = 'Error: The server could not update this record';
					this.selectedRecord = this.historyRecord;
					return;
				});

			/*** add a transaction history record ***/
			this.txService.updateTransactionHistory(this.historyRecord,
				this.selectedRecord, 'ServiceDefs', this.selectedRecord.id, ['requestType']);
		}

		/*** now update the row ***/
		this.updateSelectedRow();

	}
	public doInvokeQualificationMapping(event:any): void {
		if(this.visibleQualificationsMappingButton) {	
			this.openQualificationsDialog();
		}
	}
	/* Update the record in the table's data source - without refreshing it */
	public updateSelectedRow(): void {

		let srt = this.serviceRequestTypes.find(s => s.id === this.selectedRecord.serviceRequestTypeId);
		this.selectedRecord['requestType'] = srt.description;
		if (this.isAdd === true) {
			// add the new record to the top.
			this.records.unshift(this.selectedRecord);
			this.dataSource.data = this.records;
			this.onChangeStatusFilterValue();
			this.Idx = 0;
		} else {
			const i: number = this.records.findIndex(r => r.id === this.selectedRecord.id);
			this.records[i] = this.selectedRecord;
			this.dataSource.data = this.records;
			this.onChangeStatusFilterValue();
		}
		// do not apply the sort - it will whisk the record out of view
		// if there are large numbers of records.
		this.dataSource.sort = null;
		DwUtils.setFocus('mainTableId');

	}
	public onRowClicked(selected: any) {

		if (this.isEditing === true)
			return;

		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);
		this.historyRecord = JSON.parse(JSON.stringify(this.selectedRecord))
	}
	public cancelSubmitRecord() {
		this.strErr = '';
		this.isEditing = false;
		this.selectedRecord = this.historyRecord;
		this.displayDetail(this.selectedRecord);
		DwUtils.setFocus('mainTableId');
	}
	public closeQualificationsMappingDialog() {
		this.displayQualificationsMappingDlg = false;
	}
	public openQualificationsDialog() {
		if (!this.selectedRecord) { return; }
		this.strQualificationsdialogHeader = 'Qualifications for: ' + this.selectedRecord.description;
		this.displayQualificationsMappingDlg = true;

	}
}


